import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

function isValidCpf(value: string): boolean {
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) return false;
    const calc = (len: number) =>
        digits.slice(0, len).split('').reduce((sum, d, i) => sum + +d * (len + 1 - i), 0);
    const mod = (n: number) => (n * 10) % 11 % 10;
    return mod(calc(9)) === +digits[9] && mod(calc(10)) === +digits[10];
}

export function cpfValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) return null;
        return isValidCpf(value) ? null : {cpfValidator: true};
    };
}
